import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=6af7680e&scoped=true"
import script from "./Checkbox.vue?vue&type=script&lang=ts"
export * from "./Checkbox.vue?vue&type=script&lang=ts"
import style0 from "./Checkbox.vue?vue&type=style&index=0&id=6af7680e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af7680e",
  null
  
)

export default component.exports